"use strict";
(function (global) {
  var TEMPLATE = '/components/pick.compile.html';

/** 
* Реквизит типа «Признак».
* Предназначен для хранения значений, выбираемых из списка возможных значений. Может быть представлен в режиме для редактирования.
* 
* @since 5.0.0.4000
* @class WebAccess.components.forms.requisites.Pick
* @param {string|WebAccess.components.forms.requisites.Pick.pickSettings} id Уникальный идентификатор элемента. Параметр является обязательным
* @param {dict} values Словарь, состоящий из пар: ключ и значение элемента списка
* @param {dict} [opt_displayValues] Список элементов, которые отображаются в списке возможных значений. Например, может быть использован для дополнения  элементов списка иконками
* @param {array} [opt_disabledValues] Список элементов, недоступных для выбора
* @param {boolean} [opt_editable] Признак того, что список возможных значений можно редактировать

* @property {string} id Уникальный идентификатор реквизита
* @property {dict} values Словарь, состоящий из пар: ключ и значение элемента списка
* @property {dict} opt_displayValues Список элементов, которые отображаются в списке возможных значений
* @property {array} opt_disabledValues Список элементов, не доступных для выбора
* @property {boolean} [opt_editable] Признак того, что список возможных значений в списке можно редактировать
* @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED - заданы не все обязательные параметры.
* @fires render вызывается после того, как HTML-разметка собрана и готова к использованию.
* @example
*   var vlues = {"1": "Пункт списка 1", "2":"Пункт списка 2"};
*   var field = new WebAccess.components.forms.requisites.Pick("dropDown1", values);
*   WebAccess.current.sideBar.tabs.FldTree.setHtml(field.render());
*/

/**
* Настройки реквизита типа «Признак».
* @typedef {object} WebAccess.components.forms.requisites.Pick.pickSettings
* @property {string} id Уникальный идентификатор элемента
* @property {dict} values Словарь, состоящий из ключей элементов списка и их значений
* @property {dict} opt_displayValues Список элементов, которые отображаются в списке возможных значений 
* @property {array} opt_disabledValues Список элементов, недоступных для выбора
* @property {boolean} [opt_editable] Признак того, что список возможных значений можно редактировать
*/



  var Pick = BaseObject.extend({
    init: function (id, values, opt_displayValues, opt_disabledValues, opt_editable) {
      if (!id) return;

      this._super(id);
      if ($.isPlainObject(id)) {
        $.extend(this, id);
      } else {  
        if (!values) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");
        this.id = id;        
        this.values = values;

        this.displayValues = !!opt_displayValues ? opt_displayValues : {};
        this.disabledValues = !!opt_disabledValues ? opt_disabledValues : [];
        this.editable = !!opt_editable;        
      }

      if (this.editable === true) {
        this.values["-1"] = "";
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "Pick",    
    id: "",
    values: {"0": L("EMPTY")},
    displayValues: {},
    disabledValues: [],
    editable: false,

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
     * Собрать HTML-разметку с учетом указанных параметров
     * @function WebAccess.components.forms.requisites.Pick#render
     * @return {string} Сгенерированная HTML-разметка
     */
    render: function() {      
      var result = "";

      var requestMap = {
        "ID": this.id.toLowerCase(),
        "Values": this.values,
        "DisplayValues": this.displayValues, 
        "DisabledValues": this.disabledValues,
        "Editable": this.editable
      };
              
      CallServiceSync("/Requisite.asmx/Pick", requestMap, function (response) {
        if (response.Success) {
          result = response.Result.html;
        }
        else ShowMessage(response.Result);
      });

      this.fire("render");
      this.html = result;
      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Асинхронно генерирует HTML-разметку
    * @function WebAccess.components.forms.requisites.Pick#renderAsync
    * @return {string} Сгенерированная HTML-разметка.  
    * @since 5.2.0.1200
    */
    renderAsync: function (opt_data) {
      //TODO: Этот метод использует hogan шаблон, а для его работы необходимо много данных,
      //в том числе частично нужны данные с серверной стороны. В будущем необходимо эти
      //данные научится формировать либо получать. Сейчас пока этот метод будет работать
      //только если предоствить все данные явно. В будущем метод render(тот что выше) нужно 
      //будет переделать на него, но с флагами синхронного вызова.
      var me = this;
      var data = opt_data || me.getData();
      var result = $.Deferred();
      if (!opt_data) WA.raise('NOT_IMPLEMENTED_EXCEPTION')

      WA.templates.render(TEMPLATE, opt_data).done(function (html) {
        me.html = html;
        result.resolve(me.html);
        me.fire("render");
      });

      return result;
    }
  });
  
  global.Pick = Pick;
})(window.WebAccess.components.forms.requisites);